import Colors from 'builder/styles/colors'
import { WidgetThemeStates } from '../widget.types'
import { Service } from '../../'

const green = {
  color: Colors.Green80,
  background: Colors.Green10,
  badge: {
    color: Colors.Green50,
    background: Colors.Green15,
  },
}

const loading = {
  color: Colors.Neutral10,
  background: Colors.Neutral5,
}

type ThemeConfig = {
  service: Service
}

export const useThemeConfig = ({ service }: ThemeConfig): WidgetThemeStates => {
  const theme = {
    color: service.theme.text,
    background: service.theme.soft,
    badge: {
      color: service.theme.primary,
      background: service.theme.badge,
    },
  }

  return {
    initial: theme,
    progress: theme,
    completed: green,
    loading: loading,
  }
}
